import {
    CONFIRMED_GET_UNIT_DOSES,
    CONFIRMED_CREATE_UNIT_DOSE,
    CONFIRMED_DELETE_UNIT_DOSE,
    CONFIRMED_EDIT_UNIT_DOSE,
  } from "../types/UnitOfDoseTypes";
  
  const initialState = {
    units: [],
    num_rows: 0,
  };
  
  export default function UnitOfDoseReducer(state = initialState, action) {
    switch (action.type) {
      case CONFIRMED_GET_UNIT_DOSES:
        return {
          ...state,
          units: action.payload.units,
          num_rows: action.payload.num_rows,
        };
  
      case CONFIRMED_CREATE_UNIT_DOSE:
        return {
          ...state,
          units: [...state.units, action.payload],
        };
  
      case CONFIRMED_DELETE_UNIT_DOSE:
        return {
          ...state,
          units: state.units.filter(
            (unit) => unit.unit_dose_id !== action.payload.unit_dose_id
          ),
        };
  
      case CONFIRMED_EDIT_UNIT_DOSE:
        const updatedUnits = [...state.units];
        const index = updatedUnits.findIndex(
          (unit) => unit.unit_dose_id === action.payload.unit_dose_id
        );
  
        if (index !== -1) {
          updatedUnits[index] = action.payload;
        }
  
        return {
          ...state,
          units: updatedUnits,
        };
  
      default:
        return state;
    }
  }
  